import { gql, useMutation } from '@apollo/client';

const CUSTOMER_SIGN_IN = gql`
  mutation EmployeeSignIn(
    $email: String!
    $password: String
    $appName: String!
  ) {
    employeeSignIn(
      signInInput: { email: $email, password: $password, appName: $appName }
    ) {
      message
      status
      statusCode
      error
      data {
        token
        skipMobileVerification
        enableTimeBased2FA
        timeBased2faUri
        timeBased2faSecretKey
        roles {
          roleId
          name
          label
        }
        platformId
        company {
          companyId
          abbreviatedCompanyName
          logo
        }
        user {
          employeeId
          email
          firstName
          familyName
          userName
          mobile
          dialCode
          emailVerificationStatus
          mobileVerificationStatus
          feelEatPhoneNumber
          active
          companyId
          accessRights
          empRfidNo
          isPreferencesEnable
          isAllergiesEnable
          enableFavouriteProductNotification
          enableTimeBased2FA
        }
      }
    }
  }
`;
const useCustomerSignIn = () => {
  const [handleSignIn, { error, data, loading }] =
    useMutation(CUSTOMER_SIGN_IN);

  const signIn = (email: string, appName: string, password: string) => {
    return handleSignIn({
      variables: {
        email,
        appName,
        password,
      },
    });
  };

  return { signIn, error, data, loading };
};

export default useCustomerSignIn;
